const LaptopFaqs = () => {
return(
  <>
  </>
)
}
export default LaptopFaqs;